"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
const StyledDivider = _styled.default.div(_ref => {
  let {
    theme
  } = _ref;
  return {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '24px',
    marginTop: '24px',
    position: 'relative',
    '&::before': {
      borderTop: `1px solid ${theme.colors.grey[400]}`,
      content: '""',
      left: '0',
      margin: '0 auto',
      position: 'absolute',
      right: '0',
      top: '50%',
      zIndex: '-1'
    }
  };
});
const StyledText = _styled.default.span(_ref2 => {
  let {
    theme
  } = _ref2;
  return {
    background: theme.colors.white,
    color: theme.colors.secondary,
    fontSize: theme.fontSizes.xxSmall,
    fontWeight: theme.fontWeights.regular,
    paddingLeft: '8px',
    paddingRight: '8px'
  };
});
const Divider = _ref3 => {
  let {
    text = undefined
  } = _ref3;
  return /*#__PURE__*/_react.default.createElement(StyledDivider, null, /*#__PURE__*/_react.default.createElement(StyledText, null, text));
};
var _default = exports.default = Divider;